module.exports = __webpack_public_path__ + "static/media/reports.ccabf515.svg";